<template>
  <nav>
    <img class="logo" alt="SAMATech" src="../assets/img/logo.png">
    <div class="hamb" @click="visible = !visible"><img src="../assets/img/menu.png" width="30" alt="menu"></div>
    <ul id="nav-items" v-show="visible || bigScreen">
      <li><a @click="navClick()" href="/#">Home</a></li>
      <li><a @click="navClick()" href="/#sobre">Sobre</a></li>
      <li><a @click="navClick()" href="/cursos">Cursos e Serviços</a></li>
      <li><a @click="navClick()" href="#footer">Contato</a></li>
    </ul>
  </nav>
</template>

<style scoped lang="scss">
nav {
  padding: 0 50px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  background: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0));

  .logo {
    width: 220px;
  }
  .hamb {
    display: none;
    img {
      width: 30px;
    }
  }
  ul {
    list-style-type: none;
    display: flex;
    align-items: flex-start;
    font-family: $fonts-title;
    margin: 0;
    /*font-family: 'Muli', sans-serif;*/
    
    li {
      margin: 0 20px;
      padding: 5px;
      border-radius: 2px;
      font-size: 1.5rem;
      text-align: center;

      a {
        color: white;

        &:hover {
          border-bottom: 2px solid white;
        }
      }

      &:hover {
        /* background: $color-title; */
        /* text-shadow: 2px 2px 1px #111; */
        
      }
    }
  }
}

@media screen and (max-width:900px) {
  nav {
    position: static;
    background: none;
    background: white;
    display: block;
    padding: 0;

    .logo {
      width: 65px;
      margin-left: 10px;
    }
    .hamb {
      position: absolute;
      top: 0;
      right: 30px;
      height: 65px;
      display: flex;
      align-items: center;
      color: $color-title;
      font-size: 1.5rem;
    }
    ul {
      padding: 0;
      display: block;
      li {
        display: block;
        text-align: center;
        margin: 0;
        border-radius: 0;
        a {
          color: $color-title;
          &:hover {
            border-bottom: 0;
          }
        }

        &:hover {
          background: #eee;
          text-shadow: none;
        }
      }
    }
  }

}

</style>

<script>
module.exports = {
  data: function() {
    return {
      visible: false,
      bigScreen: false
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  methods: {
    handleResize() {
      this.bigScreen = window.innerWidth >= 900;
    },
    navClick() {
      if ( !this.bigScreen && this.visible) {
        this.visible = !this.visible;
      }
    }
  }
}
</script>
